import { render } from "./AddIconComponent.vue?vue&type=template&id=b1efe6f6"
import script from "./AddIconComponent.vue?vue&type=script&lang=js"
export * from "./AddIconComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__